<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ២.ក
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.គ​ ២.ឃ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.ង​,ច,ឆ,ជ
      </v-tab>
      <v-tab-item>
        <div v-if="preOnOff === 1">
          <prestueth
            :data="stu_pre"
            :title="title[1] + ' ' + cur_acc"
            ctitle="អាយុ<p>(ឆ្នាំ)</p>"
            :age_cont="age_cont_pre"
          />
        </div>
        <div>
          <studentpri
            :data="stu_pri"
            :age_cont="age_cont"
            :curacc="cur_acc"
            :title="title[2]"
          />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div v-if="preOnOff === 1">
          <predisable :data="dis_pre" :title="title[3]" />
        </div>
        <div>
          <dispri :data="dis_pri" type="2" :title="title[4]" />
        </div>
        <!-- 2 for pri, 3.4.5 for sec -->
      </v-tab-item>
      <v-tab-item>
        <div v-if="preOnOff === 1">
          <prestueth
            :data="eth_pre"
            :title="title[5]"
            ctitle="ជនជាតិដើមភាគ<p>តិចតាមក្រុមអាយុ</p>"
            :age_cont="age_cont_pre"
          />
        </div>
        <div>
          <ethnicpri :data="eth_pri" :age_cont="age_cont" :title="title[6]" />
          <div  v-if="preOnOff === 1">
            <preMigration :data="pre_esms" :title="title[7]" ctitle="(ចំនួនកុមារភៀសសឹក)" :curacc="cur_acc"/>
          </div>
          <priMigration :data="pri_esms" :title="title[8]" ctitle="(ចំនួនសិស្សភៀសសឹក)" :curacc="cur_acc"/>
        </div>
        <div v-if="preOnOff === 1">
          <prelaststu :data="lst_pre" :title="title[9]" :lastAcc="lst_acc" />
        </div>
        <div>
          <lststupri
            :data="lst_pri"
            :curacc="cur_acc"
            :lastacc="lst_acc"
            :cur_cod="cur_cod"
            :title="title[10]"
          />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <reentrypro
              :ree_equ="ree_equ"
              :acc_pro="acc_pro"
              :title="title[11]"
            />
          </div>
          <div><extraclass :data="ecp_pri" :title="title[12]" /></div>
        </div>
        <div class="row">
          <div><extraenrol :data="ees_pri" :title="title[13]" /></div>
          <div>
            <resultPri :data="lr_pri" :lastacc="lst_acc" :title="title[14]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import preStudentEth from "@/components/ascf/pre/preEthnic.vue";
import preMigration from "@/components/ascf/pre/preMigration.vue";
import priMigration from "@/components/ascf/pri/priMigration.vue";
import stupri from "@/components/ascf/pri/studentPri.vue";
import preDisable from "@/components/ascf/pre/preDisable.vue";
import dispri from "@/components/ascf/sharedCom/disable.vue";
import ethpri from "@/components/ascf/pri/ethnicPri.vue";
import preLastStu from "@/components/ascf/pre/preLastStudent.vue";
import lstpri from "@/components/ascf/pri/laststupri.vue";
import reentryPro from "@/components/ascf/pri/reentryProgram.vue";
import extraClass from "@/components/ascf/pri/extraClass.vue";
import extraEnrol from "@/components/ascf/pri/extraEnrol.vue";
import resultpri from "@/components/ascf/sharedCom/pResult.vue";

export default {
  props: [
    "title",
    "age_cont_pre",
    "age_cont",
    "stu_pre",
    "stu_pri",
    "dis_pre",
    "dis_pri",
    "eth_pre",
    "eth_pri",
    "lst_pre",
    "lst_pri",
    "ree_equ",
    "acc_pro",
    "ecp_pri",
    "ees_pri",
    "lr_pri",
    "pre_esms",
    "pri_esms",
    "cur_cod",
    "lst_acc",
    "cur_acc",
    "preOnOff"
  ],
  components: {
    prestueth: preStudentEth,
    studentpri: stupri,
    predisable: preDisable,
    dispri: dispri,
    ethnicpri: ethpri,
    prelaststu: preLastStu,
    lststupri: lstpri,
    reentrypro: reentryPro,
    extraclass: extraClass,
    extraenrol: extraEnrol,
    resultPri: resultpri,
    preMigration: preMigration,
    priMigration: priMigration,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>